import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import { useJob } from "../../../../context/JobContext";
import config from "../../../../config/config";
import {
   formatTimeSlots,
  cleanPersonalDetails,
  buildCompString,
  timeAgo, jobDropdownStyles, centeredContentRenderer, sortDropdownItemRenderer,
  diffMinutes, formatMinutesAsHM, formatDateStringNoDay, formatDateStringWithDayNoTime
} from "../../../../util_functions/helpers";
import {
  FaMapMarkerAlt,
  FaRedo,
  FaTimesCircle,
  FaCheckCircle,
  FaFire,
  FaBookmark,
  FaShareAlt,
  FaFlag,
  FaRegCommentDots,
  FaBell,
  FaAngleLeft,
  FaEllipsisV,
  FaRegMoneyBillAlt,
  FaRegHeart,
  FaSun, FaMoon, FaCloudSun
} from "react-icons/fa";
import { FaRegComment, FaRegCircleCheck, FaRegCircleDot, FaMoneyBills, FaMoneyBillTrendUp } from "react-icons/fa6";
import { LuRepeat } from "react-icons/lu";
import { TbFilterCog } from "react-icons/tb";
import { FiCheckCircle } from "react-icons/fi";
import { useMediaQuery } from "react-responsive";
import { IoMdTime, IoIosCheckmarkCircle } from "react-icons/io";
import { IoSparkles } from "react-icons/io5";
import { MdOutlineEventRepeat } from "react-icons/md";
import { MdAccessTime, MdAccessTimeFilled, MdWorkHistory, MdTimelapse   } from "react-icons/md";
import { AiOutlineSchedule } from "react-icons/ai";
import { TbRefresh, TbSortDescending  } from "react-icons/tb";
import { BsFillPeopleFill, BsPinMapFill, BsBookmarkCheckFill  } from "react-icons/bs";

const DiscoverJobList = () => {
  const { clientUser } = useOutletContext();
  const { jobs, fetchJobsByClientId } = useJob();
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [activeTab, setActiveTab] = useState("open");
  const [currentPage, setCurrentPage] = useState(1);
  const [jobsPerPage] = useState(10);
  const [dislikeInfo, setDislikeInfo] = useState({ visible: false, text: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [hoveredJobId, setHoveredJobId] = useState(null);
  const [filterCriteria, setFilterCriteria] = useState({
    location: "",
    supportType: "",
    postedTime: "",
  });

  const navigate = useNavigate();
  const { jobId } = useParams();
  const baseURL = config.API_BASE_URL;

  const jobType = activeTab;
  const isReduced = selectedJob && window.innerWidth > 480;
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isSmallMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isTinyMobile = useMediaQuery({ query: "(max-width: 360px)" });
  const isCompactView = isSmallMobile || isTinyMobile || isReduced;
  const [showFilter, setShowFilter] = useState(!isMobile);
  const [likeCounts, setLikeCounts] = useState({});
  const [dislikeCounts, setDislikeCounts] = useState({});
  const [likedJobs, setLikedJobs] = useState({});
  const [dislikedJobs, setDislikedJobs] = useState({});
  const [overflowOpen, setOverflowOpen] = useState(false);

  const jobDetailsRef = useRef(null);
  const overflowRef = useRef(null);

  const truncateString = (str, num) => {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  };

  const truncateTitle = (title, wordLimit) => {
    const words = title.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return title;
  };

  const getJobTitleDisplay = (job) => {
    const title = getNestedProperty(job, "jobCraftDetails.jobTitle");
    return isReduced ? truncateString(title, 60) : title;
  };

  useEffect(() => {
    if (clientUser?.id) {
      console.log("Logged-in userId:", clientUser.id);
      console.log(`Name: ${clientUser.firstName} ${clientUser.lastName}`);
      fetchJobsByClientId(clientUser.id);
    }
  }, [fetchJobsByClientId, clientUser]);

  useEffect(() => {
    if (isMobile && selectedJob) {
      setShowDetails(true);
    } else if (!isMobile) {
      setShowDetails(false);
    }
  }, [isMobile, selectedJob]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 && selectedJob) {
        setShowDetails(true);
      } else if (window.innerWidth > 768) {
        setShowDetails(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedJob]);

  useEffect(() => {
    if (selectedJob && selectedJob.frequencyDetails) {
      const { scheduling, preferredDays } = selectedJob.frequencyDetails;
      if (scheduling === "Preferred" || scheduling === "Flexible") {
        console.log(`Selected Job Scheduling: ${scheduling}`);
        if (preferredDays) {
          console.log("Selected Job Preferred Days:", preferredDays);
        }
      }
    }
  }, [selectedJob]);

  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname ===
      `/account/fs-dashboard/my-jobs/${jobType}/${jobId}` &&
      jobId
    ) {
      const jobToDisplay = jobs.find((job) => job.id === jobId);
      if (jobToDisplay) {
        setSelectedJob(jobToDisplay);
        setShowDetails(true);
      }
    } else if (
      location.pathname.includes(`/account/fs-dashboard/my-jobs/${jobType}`)
    ) {
      setShowDetails(false);
      setSelectedJob(null);
    }
  }, [location, jobId, jobType, jobs]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768 && selectedJob) {
        setShowDetails(true);
      } else if (window.innerWidth > 768) {
        setShowDetails(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedJob]);

  useEffect(() => {
    const filtered = jobs.filter((job) => {
      const matchesSearchQuery =
        searchQuery === "" ||
        job.jobCraftDetails.jobTitle
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        job.jobCraftDetails.jobDescription
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      const matchesLocation =
        filterCriteria.location === "" ||
        (job.suburbValue &&
          job.suburbValue
            .toLowerCase()
            .includes(filterCriteria.location.toLowerCase()));

      const matchesSupportType =
        filterCriteria.supportType === "" ||
        job.frequencyDetails.supportType === filterCriteria.supportType;

      const matchesPostedTime =
        filterCriteria.postedTime === "" ||
        new Date(job.postedTime).getTime() >=
        getRelativeTimeInMillis(filterCriteria.postedTime);

      console.log({
        matchesSearchQuery,
        matchesLocation,
        matchesSupportType,
        matchesPostedTime,
      });

      return (
        matchesSearchQuery &&
        matchesLocation &&
        matchesSupportType &&
        matchesPostedTime
      );
    });
    setFilteredJobs(filtered);
    setSelectedJob(null);
    setShowDetails(false);
  }, [searchQuery, filterCriteria, jobs]);

  const handleJobSelect = (job, element) => {
    navigate(`/account/fs-dashboard/my-jobs/${jobType}/${job.id}`, {
      state: { selectedJobId: job.id },
    });
    setSelectedJob(job);
    setShowDetails(true);
    console.log("Selected Job:", job);
    smoothScrollToTop();
    setTimeout(() => {
      const isMobileView = window.innerWidth <= 768;
      if (isMobileView) {
        const mobileContainer = document.querySelector(
          ".mobile-job-items-container"
        );
        if (mobileContainer) {
          const jobElement = mobileContainer.querySelector(
            ".mobile-job-item.selected"
          );
          if (jobElement) {
            const containerRect = mobileContainer.getBoundingClientRect();
            const jobRect = jobElement.getBoundingClientRect();
            const scrollTo =
              jobElement.offsetLeft +
              jobRect.width / 2 -
              containerRect.width / 2;

            mobileContainer.scrollTo({
              left: scrollTo,
              behavior: "smooth",
            });
          }
        }
      } else {
        centerSelectedItem(element, false);
      }
    }, 0);
  };

  const smoothScrollToTop = () => {
    const element = jobDetailsRef.current;
    if (element) {
      const scrollDuration = 600;
      const scrollStep = -element.scrollTop / (scrollDuration / 15);
      const scrollInterval = setInterval(() => {
        if (element.scrollTop !== 0) {
          element.scrollTop += scrollStep;
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
    }
  };

  const handleBackClick = () => {
    navigate(`/account/fs-dashboard/my-jobs/${jobType}`);
    setShowDetails(false);
    setSelectedJob(null);
  };

  const handleLike = (e, job) => {
    e.stopPropagation();
    setLikeCounts((prevCounts) => ({
      ...prevCounts,
      [job.id]: (prevCounts[job.id] || 0) + 1,
    }));
    console.log("Liked job:", job);
  };

  const handleDislike = (e, job) => {
    e.stopPropagation();
    setDislikeCounts((prevCounts) => ({
      ...prevCounts,
      [job.id]: (prevCounts[job.id] || 0) + 1,
    }));
    setDislikeInfo({
      visible: true,
      text: "Reason for disliking the job goes here.",
    });
    console.log("Disliked job:", job);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilterCriteria({
      ...filterCriteria,
      [e.target.name]: e.target.value,
    });
  };

  const keyDisplayName = {
    "jobCraftDetails.jobTitle": "Job Title",
    "jobCraftDetails.jobDescription": "Job Description",
    postedTime: "Posted Time",
    supportLabels: "Support Type(s)",
    careActivityDetails: "Care Activity Details",
    "supportJobLocationDetails.supportJobLocation": "Support Workplace",
    suburbValue: "Job Location",
    "frequencyDetails.supportType": "Job Frequency",
    "frequencyDetails.sessionsPerWeek": "Sessions Per Week",
    "frequencyDetails.totalHoursPerWeek": "Total Hours Per Week",
    "frequencyDetails.supportStartDate": "Support Starting Date",
    "frequencyDetails.scheduling": "Schedule",
    "frequencyDetails.additionalDetails": "Additional Details",
    "frequencyDetails.preferredDays": "Preferred Days",
    "jobCraftDetails.personalDetails": "Personal Details",
    "supportJobLocationDetails.preferredQualities": "Preferred Qualities",
    "supportJobLocationDetails.preferredGender": "Preferred Gender",
    postedBy: "Posted By",
    clientId: "Client Id",
    id: "Job ID",
  };

  const getNestedProperty = (job, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], job);
  };

  const formatPreferredDays = (preferredDays) => {
    const dayEntries = Object.entries(preferredDays);

    const activeDays = dayEntries
      .filter(([_, isPreferred]) => isPreferred)
      .map(([day]) => day);

    if (activeDays.length > 0) {
      console.log("Preferred Days:", activeDays.join(", "));
    } else {
      console.log("No preferred days returned");
    }
  };

  const displayOrder = [
    "postedTime",
    "supportLabels",
    "careActivityDetails",
    "jobCraftDetails.jobDescription",
    "frequencyDetails.supportType",
    "suburbValue",
    "supportJobLocationDetails.supportJobLocation",
    "frequencyDetails.sessionsPerWeek",
    "frequencyDetails.totalHoursPerWeek",
    "frequencyDetails.supportStartDate",
    "frequencyDetails.scheduling",
    "frequencyDetails.preferredDays",
    "frequencyDetails.timeSlots",
    "frequencyDetails.additionalDetails",
    "jobCraftDetails.personalDetails",
    "supportJobLocationDetails.preferredQualities",
    "supportJobLocationDetails.preferredGender",
    "postedBy",
  ];

  const getRelativeTimeInMillis = (input) => {
    const now = new Date();
    const [amount, unit] = input.split(" ");
    const value = parseInt(amount, 10);

    switch (unit) {
      case "minute":
      case "minutes":
        return now - value * 60 * 1000;
      case "hour":
      case "hours":
        return now - value * 60 * 60 * 1000;
      case "day":
      case "days":
        return now - value * 24 * 60 * 60 * 1000;
      case "week":
      case "weeks":
        return now - value * 7 * 24 * 60 * 60 * 1000;
      case "month":
      case "months":
        return now - value * 30 * 24 * 60 * 60 * 1000;
      default:
        return now;
    }
  };

  const handleResetFilters = () => {
    setSearchQuery("");
    setFilterCriteria({
      location: "",
      supportType: "",
      postedTime: "",
    });
  };

  const cleanJobDescription = (htmlString) => {
    console.log("Original HTML:", htmlString);

    const cleanedHTML = htmlString.replace(/<p>\s*<br>\s*<\/p>/g, "");

    console.log("Cleaned HTML:", cleanedHTML);

    return cleanedHTML;
  };

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);
  const maxPageNumbersToShow = 5;
  const halfPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

  const startPage = Math.max(1, currentPage - halfPageNumbersToShow);
  const endPage = Math.min(totalPages, currentPage + halfPageNumbersToShow);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (action) => {
    if (action === "previous" && currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    } else if (action === "next" && currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    } else if (typeof action === "number") {
      setCurrentPage(action);
    }
  };

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const centerSelectedItem = (element, forceMobileScroll) => {
    const scrollContainer = forceMobileScroll
      ? document.querySelector(".mobile-job-items-container")
      : document.querySelector(".job-list");

    if (!scrollContainer) {
      console.error("Scroll container not found.");
      return;
    }

    const elementRect = element.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();

    const scrollTo = forceMobileScroll
      ? element.offsetLeft + elementRect.width / 2 - containerRect.width / 2
      : element.offsetTop + elementRect.height / 2 - containerRect.height / 2;

    scrollContainer.scroll({
      left: forceMobileScroll ? scrollTo : 0,
      top: !forceMobileScroll ? scrollTo : 0,
      behavior: "smooth",
    });
  };

  const fmtHours = (v) => (v == null ? "-" : v);

  const onSave = () => {
    if (!selectedJob) return;
    console.log("Save clicked for job", selectedJob.id);
  };

  const onShare = () => {
    if (!selectedJob) return;
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    console.log("Share clicked for job", selectedJob.id, "link copied:", url);
    if (navigator.share) {
      navigator.share({ title: selectedJob.title, url }).catch(() => { });
    }
  };

  const onReport = () => {
    if (!selectedJob) return;
    console.log("Report clicked for job", selectedJob.id);
  };

  const onSetAlert = () => {
    if (!selectedJob) return;
    console.log("Set Alert clicked for job", selectedJob.id);
  };

   const wordForCount = (n, singular, plural = `${singular}s`) =>
    Number(n) === 1 ? singular : plural;

  const summarizeSessionRanges = (ranges, isSmallMobile = false) => {
    if (!Array.isArray(ranges) || ranges.length === 0) return null;

    const labels = ranges.map(r => r?.label).filter(Boolean);
    const unique = Array.from(new Set(labels));
    if (unique.length === 0) return null;

    let first = unique[0];
    if (isSmallMobile && first.includes("hr") && first.includes("min")) {
      first = first.replace(/\s+\d+\s*mins?$/, "..");
    }

    return {
      first,
      rest: unique.slice(1),
      count: unique.length
    };
  };

  const getSelectedLocationsSafe = (job) => {
    const raw = Array.isArray(job?.selectedLocations) ? job.selectedLocations : [];
    const list = raw.filter(Boolean).map((s) => String(s).trim()).filter(Boolean);

    if (list.length === 0 && job?.suburbValue) return [job.suburbValue];

    const seen = new Map();
    for (const loc of list) {
      const key = loc.toLowerCase();
      if (!seen.has(key)) seen.set(key, loc);
    }
    return Array.from(seen.values());
  };

  const splitLocation = (s) => {
    const str = String(s ?? "").trim();
    const m = str.match(/^(.*?)\s+([A-Z]{2})\s+(\d{5}(?:-\d{4})?)$/);
    if (m) return { place: m[1], state: m[2], zip: m[3] };
    return { place: str || "-", state: "", zip: "" };
  };

  const ListedApplications = ({ job, isSmallMobile = false }) => (
    <div className="listed-applications-container sm">
      <span className="application-count">
        <BsFillPeopleFill className="application-count-icon" />
        <span className="application-count-text">
          <span className="job-detail-label">
            <span className="applicant-count-chip">
              {/* {job.applicationCount}
              {job.applicationCount > 10 ? "+" : ""} */}
              10+
            </span>
            <strong>Applicant{job.applicationCount !== 1 ? "s" : ""}</strong>
          </span>
        </span>
        <span className="application-count">
          <span className="listed-time-value">
            <span className="job-detail-label">|&nbsp; Posted</span> <strong>{timeAgo(job.postedTime, isSmallMobile)}</strong> ago
          </span>
        </span>
      </span>
    </div>
  );

  return (
    <div className="jobs-and-filter-container">
      <div className="supportclaim-header-container">
        <div className="supportclaim-header-container">
        {!showFilter && (
        <div className="supportclaim-header">
          {isMobile && !showDetails && (
            <div className="filter-toggle-container filter-show" onClick={toggleFilter}>
              <TbFilterCog className="filter-toggle-icon" />
              <span>Filters</span>
            </div>
          )}
        </div>
         )}
        {(!isMobile || showFilter) && (
          <div className="hide-and-filter-wrapper">
          <div>
            {showFilter && isMobile && (
              <div className="filter-close" onClick={toggleFilter} aria-label="Close filters">
                <FaTimesCircle />
              </div>
            )}
          </div>
          <div className={`job-search-filter ${isMobile ? "mobile" : ""}`}>
            <div className="claim-filter-itemwn">
              <label htmlFor="client-name-filter">
                Filter by Job title
              </label>
              <input
                type="text"
                placeholder="Filter jobs by title ..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <div className="claim-filter-itemwn">
              <label htmlFor="client-name-filter">
                Filter by Location
              </label>
              <select
                name="location"
                value={filterCriteria.location}
                onChange={handleFilterChange}
              >
                <option value="">All Locations</option>
                {Array.from(new Set(jobs.map((job) => job.suburbValue))).map(
                  (location) => (
                    <option key={location} value={location}>
                      {location}
                    </option>
                  )
                )}
              </select>
            </div>
            <div className="claim-filter-itemwn">
              <label htmlFor="client-name-filter">
                Support Type
              </label>
              <select
                name="supportType"
                value={filterCriteria.supportType}
                onChange={handleFilterChange}
              >
                <option value="">All Support Types</option>
                {Array.from(
                  new Set(jobs.map((job) => job.frequencyDetails.supportType))
                ).map((supportType) => (
                  <option key={supportType} value={supportType}>
                    {supportType}
                  </option>
                ))}
              </select>
            </div>
            <div className="claim-filter-itemwn">
              <label htmlFor="client-name-filter">
                Posted Time
              </label>
              <select
                name="postedTime"
                value={filterCriteria.postedTime}
                onChange={handleFilterChange}
              >
                <option value="">Any Time</option>
                <option value="less than an hour ago">Less than an hour ago</option>
                <option value="less than a day ago">Less than a day ago</option>
                <option value="less than a week ago">Less than a week ago</option>
                <option value="less than a month ago">Less than a month ago</option>
              </select>
            </div>
            <div className="clear-filters-container">
              <button
                className="clear-job-filters-button"
                onClick={handleResetFilters}
              >
                <FaRedo className="job-filter-reset" /> Reset
              </button>
            </div>
          </div>
          </div>
        )}
      </div>
       {(!isMobile || !showFilter) && (
      <div className="jobs-create-new">
        <Link
          to="/account/fs-dashboard/my-jobs/new"
          className="post-job-link-new"
        >
          Post New Job
        </Link>
      </div>
    )}
    </div>
      {isMobile && selectedJob && (
        <div className="mobile-job-items-container">
          {filteredJobs.map((job) => (
            <div
              key={job.id}
              className={`mobile-job-item ${selectedJob && job.id === selectedJob.id ? "selected" : ""
                }`}
              onClick={(e) => handleJobSelect(job, e.currentTarget)}
            >
              <div className="mobile-job-item-details">
                <h3 className="mobile-job-title">{getJobTitleDisplay(job)}</h3>
                <div className="job-location">
                  <FaMapMarkerAlt className="mobile-job-detail fa-map-marker-alt" />
                  <span>{job.suburbValue}</span>
                </div>
                <div className="job-posted-time">
                  <AiOutlineSchedule className="mobile-job-detail fa-clock" />
                  <span>Posted {timeAgo(job.postedTime)} ago</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="active-jobs-container">
        {filteredJobs.length === 0 ? (
          <div className="no-jobs-placeholder">
            <img
              src="/images/no_results_found.png"
              alt="No results found"
              className="no-jobs-image"
            />
            <p>No jobs posted yet.</p>
          </div>
        ) : (
          <div
            className={`job-list ${selectedJob && !isMobile ? "reduced" : ""} ${!showDetails && isMobile ? "show" : ""
              }`}
          >
            {filteredJobs.map((job) => {
                const currentTime = new Date();
                const postTime = new Date(job.postedTime);
                const diffInSeconds = Math.floor((currentTime - postTime) / 1000);
                const isNew = diffInSeconds < 10800;

                return (
                  <div className="job-item-likes-container">
                    <div
                      key={job.id}
                      className={`job-item-container ${selectedJob && job.id === selectedJob.id ? "selected" : ""
                        }`}
                    >
                      <div
                        id={`job-${job.id}`}
                        className={`job-item ${selectedJob && job.id === selectedJob.id ? "selected" : ""
                          }`}
                        onClick={(e) => handleJobSelect(job, e.currentTarget)}
                      >
                        <h3>
                          {(!isReduced && !isMobile)
                            ? job.jobCraftDetails.jobTitle
                            : (hoveredJobId === job.id
                              ? job.jobCraftDetails.jobTitle
                              : truncateTitle(job.jobCraftDetails.jobTitle, 10)
                            )
                          }
                        </h3>
                        <div className="job-item-content">
                          <div className="job-content-likes-container">
                            <div className="job-item-left-right-container">
                              <div className="job-item-left">

                                <div className="job-and-rate">
                                  <p className="job-detail-dashboard">
                                    <span className="shift-chip added-span-style type-pay-style">
                                      <MdWorkHistory className="job-check-icon" />
                                      {job.frequencyDetails?.jobType || "-"}
                                    </span>
                                    <span className="shift-chip added-span-style type-pay-style">
                                      <FaMoneyBills    className="job-pay-icon" />
                                      {buildCompString(job.frequencyDetails, { compact: isTinyMobile || isSmallMobile || isReduced })}
                                    </span>
                                  </p>
                                </div>

                                <div className="job-location-wrapper">
                                  <p className="job-detail-dashboard">
                                    <span className="job-detail-label">
                                      <FaMapMarkerAlt className="job-location-icon fa-map-marker-alt" />
                                      {/* {!(isSmallMobile || isReduced) && (
                                      <>
                                        <strong>Location</strong>
                                        <span className="user-dashboard-arrow">➤</span>
                                      </>
                                    )} */}
                                    </span>


                                    {(() => {
                                      const locs = getSelectedLocationsSafe(job);
                                      const first = locs[0] ?? "-";
                                      const moreCount = Math.max(0, locs.length - 1);
                                      const rest = locs.slice(1);

                                      const { place, state, zip } = splitLocation(first);

                                      let displayPlace = place;
                                      if (place.length > 15) {
                                        displayPlace = place.slice(0, 12).trim() + "...";
                                      }

                                      return (
                                        <span className={`job-detail-value ${moreCount > 0 ? "has-more" : ""}`}>
                                          <span className="location-area-first" title={first} aria-label={first}>
                                            <span>{displayPlace}</span>
                                            {(state || zip) && (
                                              <span className="location-state-zip">{state} {zip}</span>
                                            )}
                                          </span>
                                          {moreCount > 0 && (
                                            <>
                                              <span
                                                className={`shift-chip shift-chip--more ${isTinyMobile ? "shift-chip--more-xs" : ""}`}
                                                title={rest.join(", ")}
                                                aria-label={`${moreCount} more location${moreCount > 1 ? "s" : ""}: ${rest.join(", ")}`}
                                              >
                                                +{moreCount} more
                                              </span>
                                            </>
                                          )}
                                        </span>
                                      );
                                    })()}
                                  </p>
                                </div>


                                <div className="sessions-recurrence-wrapper">
                                <p className="job-detail-dashboard">
                                  <span className="job-detail-label">
                                    {/* <MdOutlineEventRepeat className="job-detail-icon chckmrk-outline" /> */}
                                  </span>
                                    <span className="shift-chip added-span-style type-pay-style">
                                      {/* <MdWorkHistory className="job-check-icon" /> */}
                                      <BsBookmarkCheckFill    className="job-check-icon chckmrk-outline" />
                                      {job.frequencyDetails?.supportType || "-"}
                                    </span>

                                    <span className="shift-chip type-pay-style">
                                      {getNestedProperty(job, "frequencyDetails.sessionsPerWeek")}{" "}
                                      {wordForCount(getNestedProperty(job, "frequencyDetails.sessionsPerWeek"), "Session")}
                                    </span>
                                  
                                </p>
                                </div>
                                {!(isSmallMobile || isReduced) && isNew && (
                                  <>
                                    <div className="apply-early-container">
                                      <div className="job-new-badge">
                                        <IoSparkles className="job-new-icon" />
                                        <span className="job-new-text">New</span>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>

                              {!(isSmallMobile || isReduced) && <div className="vertical-separator"></div>}

                              <div className="job-item-right">

                                <p className="job-detail-dashboard">
                                  <span className="job-detail-label">
                                    <MdTimelapse className="job-detail-icon fa-clock" />
                                    <strong>
                                      {(() => {
                                        const raw = job.frequencyDetails?.shiftTypes || [];
                                        const shifts = Array.from(
                                          new Map(
                                            raw.filter(Boolean).map((s) => [s.trim().toLowerCase(), s.trim()])
                                          ).values()
                                        ).map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());

                                        if (shifts.length === 0) return "Shift Schedule";
                                        if (shifts.length === 1) return "Shift Schedule";
                                        return "Shifts";
                                      })()}
                                    </strong>
                                    <span className="job-dashboard-arrow">➤</span>
                                  </span>

                                  <span className="job-detail-value">
                                    <span className="job-detail-value">
                                      <div className="job-shifts-container">
                                        {(() => {
                                          const raw = job.frequencyDetails?.shiftTypes || [];
                                          const shifts = Array.from(
                                            new Map(
                                              raw.filter(Boolean).map((s) => [s.trim().toLowerCase(), s.trim()])
                                            ).values()
                                          ).map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase());

                                          const shiftIconMap = {
                                            Day: <FaSun className="job-check-icon" />,
                                            Evening: <FaCloudSun className="job-check-icon" />,
                                            Night: <FaMoon className="job-check-icon" />,
                                          };

                                          if (shifts.length === 0) {
                                            return (
                                              <span className="shift-chip type-pay-style">
                                                {/* <FaCheckCircle className="job-check-icon" />Flexible */}
                                              </span>
                                            );
                                          }

                                          if (isCompactView) {
                                            const [first, ...rest] = shifts;
                                            let displayFirst = first;
                                            if (displayFirst.length > 12) {
                                              displayFirst = displayFirst.slice(0, 10).trim() + "...";
                                            }

                                            return (
                                              <>
                                                <span className="shift-chip type-pay-style">
                                                  {/* {shiftIconMap[first]} */}
                                                  {displayFirst}
                                                </span>
                                                {rest.length > 0 && (
                                                  <span
                                                    className="shift-chip shift-chip--more"
                                                    title={rest.join(", ")}
                                                    aria-label={`+${rest.length} more: ${rest.join(", ")}`}
                                                  >
                                                    +{rest.length} more
                                                  </span>
                                                )}
                                              </>
                                            );
                                          }

                                          return shifts.map((s, i) => (
                                            <span className="shift-chip type-pay-style" key={i}>
                                              {/* {shiftIconMap[s]} */}
                                              {s}
                                            </span>
                                          ));
                                        })()}
                                      </div>
                                    </span>
                                  </span>
                                </p>

                                {(() => {
                                  const sr = summarizeSessionRanges(job.frequencyDetails?.sessionRanges, isSmallMobile);

                                  const hasHoursPerSession = getNestedProperty(job, "frequencyDetails.hoursPerSession") != null;

                                  if (sr) {
                                    let displayFirst = sr.first;
                                    if (isCompactView && displayFirst.length > 12) {
                                      displayFirst = displayFirst.slice(0, 6).trim() + "...";
                                    }

                                    return (
                                      <p className="job-detail-dashboard">
                                        <span className="job-detail-label">
                                          <IoMdTime  className="job-detail-icon chckmrk-outline" />
                                          <strong>{sr.count > 1 ? "Time Slots" : "Time Slot"}</strong>
                                          <span className="job-dashboard-arrow">➤</span>
                                        </span>
                                        <span className="job-detail-value">
                                          <div className="job-shifts-container">
                                            <span className="shift-chip type-pay-style">
                                              {/* <MdAccessTimeFilled className="job-check-icon" /> */}
                                              {displayFirst}</span>
                                            {sr.count > 1 && (
                                              <span
                                                className="shift-chip shift-chip--more"
                                                title={sr.rest.join(", ")}
                                                aria-label={`+${sr.count - 1} more: ${sr.rest.join(", ")}`}
                                              >
                                                +{sr.count - 1} more
                                              </span>
                                            )}
                                          </div>
                                        </span>
                                      </p>
                                    );
                                  }



                                  if (hasHoursPerSession) {
                                    return (
                                      <p className="job-detail-dashboard">
                                        <span className="job-detail-label">
                                          <MdAccessTime className="job-detail-icon chckmrk-outline" />
                                          <strong>Time Slot</strong>
                                          <span className="job-dashboard-arrow">➤</span>
                                        </span>
                                        <span className="shift-chip type-pay-style">
                                          {(() => {
                                            const hrs = getNestedProperty(job, "frequencyDetails.hoursPerSession");
                                            if (hrs == null) return "-";
                                            return (
                                              <>
                                                {/* <FaCheckCircle className="job-check-icon" /> */}
                                                {fmtHours(hrs)} {hrs === 1 ? "hr" : "hrs"}
                                              </>
                                            );
                                          })()}
                                        </span>

                                      </p>
                                    );
                                  }

                                  return null;
                                })()}

                                {!isSmallMobile && <ListedApplications job={job} />}

                              </div>
                            </div>
                            {!isReduced && (
                              <div className="job-item-icons">
                                {(() => {
                                  const lid = job.id;
                                  const likeCount = likeCounts[lid] ?? 689;
                                  const dislikeCount = dislikeCounts[lid] ?? 60;

                                  const isLikeActive = !!likedJobs[lid] || likeCount > 0;
                                  const isDislikeActive = !!dislikedJobs[lid] || dislikeCount > 0;

                                  return (
                                    <>
                                      <div className="likes-container">
                                        <div className="likes-icon-container">
                                          <FaRegHeart
                                            className={`like-icon ${isLikeActive ? "active-like" : ""}`}
                                            aria-pressed={isLikeActive}
                                            onClick={(e) => handleLike(e, job)}
                                            title="Like"
                                          />
                                        </div>
                                        <span className="like-count">{likeCount}</span>
                                      </div>

                                      <div className="dislikes-container">
                                        <div className="dislikes-icon-container">
                                          <FaRegComment
                                            className={`dislike-icon ${isDislikeActive ? "active-dislike" : ""}`}
                                            aria-pressed={isDislikeActive}
                                            onClick={(e) => handleDislike(e, job)}
                                            title="Dislike"
                                          />
                                        </div>
                                        <span className="dislike-count">{dislikeCount}</span>
                                      </div>
                                    </>
                                  );
                                })()}
                              </div>
                            )}
                          </div>


                          {isSmallMobile && <ListedApplications job={job} isSmallMobile />}

                          {(isReduced || isSmallMobile) && isNew && (
                            <>
                              <div className="apply-early-container">
                                <div className="job-new-badge">
                                  <IoSparkles className="job-new-icon" />
                                  <span className="job-new-text">New</span>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                );
              })}
            {jobs.length > 0 && (
              <div className="active-jobs-pagination">
                <button
                  onClick={() => handlePageChange("first")}
                  disabled={currentPage === 1}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => handlePageChange("previous")}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
                <span>
                  Page <strong>{currentPage}</strong> of{" "}
                  <strong>{totalPages > 99 ? "99+" : totalPages}</strong>
                </span>
                <button
                  onClick={() => handlePageChange("next")}
                  disabled={currentPage >= totalPages}
                >
                  &gt;
                </button>
                <button
                  onClick={() => handlePageChange("last")}
                  disabled={currentPage >= totalPages}
                >
                  &raquo;
                </button>
              </div>
            )}
          </div>
        )}
        {selectedJob && (
          <div
            ref={jobDetailsRef}
            className={`job-details ${showDetails || window.innerWidth > 480 ? "show" : "hidden"
              }`}
          >
            <div className="job-likes-apply">

                <div className="action-items-container">
                  <div className="job-item-icons-big">
                    {isMobile && (
                      <div
                        className="job-details-back"
                        onClick={handleBackClick}
                        aria-label="Back to list"
                      >
                        <FaAngleLeft className="job-details-back-icon" />
                      </div>
                    )}

                    <div className="likes-dislikes-wrapper">
                      {(() => {
                        const lid = selectedJob.id;
                        const likeCount = likeCounts[lid] ?? 90;
                        const dislikeCount = dislikeCounts[lid] ?? 3;

                        const isLikeActive = !!likedJobs[lid] || likeCount > 0;
                        const isDislikeActive = !!dislikedJobs[lid] || dislikeCount > 0;

                        return (
                          <>
                            <div className="likes-container">
                              <div className="likes-icon-container">
                                <FaRegHeart
                                  className={`like-icon ${isLikeActive ? "active-like" : ""}`}
                                  aria-pressed={isLikeActive}
                                  onClick={(e) => handleLike(e, selectedJob)}
                                  title="Like"
                                />
                              </div>
                              <span className="like-count">{likeCount}</span>
                            </div>

                            <div className="dislikes-container">
                              <div className="dislikes-icon-container">
                                <FaRegComment
                                  className={`dislike-icon ${isDislikeActive ? "active-dislike" : ""}`}
                                  aria-pressed={isDislikeActive}
                                  onClick={(e) => handleDislike(e, selectedJob)}
                                  title="Dislike"
                                />
                              </div>
                              <span className="dislike-count">{dislikeCount}</span>
                            </div>
                          </>
                        );
                      })()}
                    </div>


                    <div className="job-item-actions-common">
                      {isMobile ? (
                        <div className="mobile-actions">
                          <div
                            className="job-save-container action-button"
                            onClick={() => onSave(selectedJob)}

                            aria-label="Save job"
                            role="button"
                            tabIndex={0}
                          >
                            <FaBookmark /> <span className="visually-hidden">Save</span>
                          </div>
                          <div
                            className="job-share-container action-button"
                            onClick={onShare}
                            aria-label="Share job"
                            role="button"
                            tabIndex={0}
                          >
                            <FaShareAlt /> <span className="visually-hidden">Share</span>
                          </div>
                          <div className="overflow-wrapper" ref={overflowRef}>
                            <div
                              className="overflow-trigger action-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOverflowOpen((o) => !o);
                              }}
                              aria-haspopup="menu"
                              aria-expanded={overflowOpen}
                              role="button"
                              tabIndex={0}
                              aria-label="More actions"
                            >
                              <FaEllipsisV />
                            </div>
                            {overflowOpen && (
                              <div
                                className="overflow-menu"
                                role="menu"
                                aria-label="More job actions"
                              >
                                <div
                                  className="overflow-item"
                                  role="menuitem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onReport(selectedJob);
                                    setOverflowOpen(false);
                                  }}
                                >
                                  <FaFlag className="overflow-icon" /> <span>Report</span>
                                </div>
                                <div
                                  className="overflow-item"
                                  role="menuitem"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onSetAlert(selectedJob);
                                    setOverflowOpen(false);
                                  }}
                                >
                                  <FaBell className="overflow-icon" /> <span>Set Alert</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="job-item-actions-common">
                          <div
                            className="job-save-container action-button"
                            onClick={onSave}
                            role="button"
                            tabIndex={0}
                          >
                            <FaBookmark /> <span>Save</span>
                          </div>
                          <div
                            className="job-share-container action-button"
                            onClick={onShare}
                            role="button"
                            tabIndex={0}
                          >
                            <FaShareAlt /> <span>Share</span>
                          </div>
                          <div
                            className="job-report-container action-button"
                            onClick={onReport}
                            role="button"
                            tabIndex={0}
                          >
                            <FaFlag /> <span>Report</span>
                          </div>
                          <div
                            className="job-reminder-container action-button"
                            onClick={onSetAlert}
                            role="button"
                            tabIndex={0}
                          >
                            <FaBell /> <span>Set Alert</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            <div className="job-detail-content">
              <h2>
                {getNestedProperty(selectedJob, "jobCraftDetails.jobTitle")}
              </h2>
              {displayOrder.map((key) => {
                const detail = getNestedProperty(selectedJob, key);
                if (!detail) return null;
                if (key === "jobCraftDetails.personalDetails") {
                  return (
                    <div key={key}>
                      <h4 className="personal-details-header">
                        Personal Details
                      </h4>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: cleanPersonalDetails(
                            getNestedProperty(
                              selectedJob,
                              "jobCraftDetails.personalDetails"
                            )
                          ),
                        }}
                      ></div>
                    </div>
                  );
                } else if (key === "jobCraftDetails.jobDescription") {
                  return (
                    <div key={key}>
                      <h4>Job Description</h4>
                      <div
                        className="job-details-description"
                        dangerouslySetInnerHTML={{
                          __html: cleanJobDescription(
                            getNestedProperty(
                              selectedJob,
                              "jobCraftDetails.jobDescription"
                            )
                          ),
                        }}
                      ></div>
                    </div>
                  );
                }
                if (key === "frequencyDetails.preferredDays") {
                  if (selectedJob.frequencyDetails.scheduling === "Preferred") {
                    if (
                      selectedJob.frequencyDetails.preferredDays &&
                      Object.values(
                        selectedJob.frequencyDetails.preferredDays
                      ).some(Boolean)
                    ) {
                      return (
                        <div key="preferredDays">
                          <h4>Preferred Days</h4>
                          <p>
                            {formatPreferredDays(
                              selectedJob.frequencyDetails.preferredDays
                            )}
                          </p>
                        </div>
                      );
                    }
                  }
                } else if (
                  key === "frequencyDetails.timeSlots" &&
                  selectedJob.frequencyDetails.scheduling === "Preferred"
                ) {
                  return (
                    <div key={key}>
                      <h4>Preferred Days & Time Slots</h4>
                      {detail && Object.keys(detail).length ? (
                        formatTimeSlots(detail)
                      ) : (
                        <p>No time slots specified.</p>
                      )}
                    </div>
                  );
                }
                if (key === "frequencyDetails.preferredDays") {
                  if (selectedJob.frequencyDetails.scheduling === "Flexible") {
                    if (
                      selectedJob.frequencyDetails.preferredDays &&
                      Object.values(
                        selectedJob.frequencyDetails.preferredDays
                      ).some(Boolean)
                    ) {
                      return (
                        <div key="preferredDays">
                          <h4>Preferred Days</h4>
                          <p>
                            {formatPreferredDays(
                              selectedJob.frequencyDetails.preferredDays
                            )}
                          </p>
                        </div>
                      );
                    }
                  }
                } else if (
                  key === "frequencyDetails.timeSlots" &&
                  selectedJob.frequencyDetails.scheduling === "Flexible"
                ) {
                  return (
                    <div key={key}>
                      <h4>Preferred Days & Time Slots</h4>
                      {detail && Object.keys(detail).length ? (
                        formatTimeSlots(detail)
                      ) : (
                        <p>No time slots specified.</p>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div key={key}>
                      <h4>{keyDisplayName[key] || key}</h4>
                      <p>
                        {Array.isArray(detail) ? detail.join(", ") : detail}
                      </p>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscoverJobList;
